import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { FieldDictionaryDto, SingleResponseModel } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DELETESUCCESS, EDITSUCCESS, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-base-field-config',
  templateUrl: './base-field-config.component.html',
  styleUrl: './base-field-config.component.scss'
})
export class BaseFieldConfigComponent<T> implements OnInit {
  form: FormGroup;
  fieldName;
  editId;
  fieldData;

  constructor(private formBuilder: FormBuilder, private fieldsConfigService: FieldsConfigService<T>,
    private baseService: BaseService, @Inject(MAT_DIALOG_DATA) public data, private translate: TranslateService) {
    this.fieldName = data.fieldName;
    this.fieldData = data.fielddata;
  }

  ngOnInit(): void {
    this.buildForm();
    this.getFieldData();
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      'id': [null],
      'tabsystemmenuid': [null, [Validators.required]],
      'fieldname': [null, [Validators.required]],
      'displayaraname': [''],
      'dislaylatname': [''],
      'fieldtype': [''],
      'displaylist': [false],
      'filter': [false],
      'criteria': [false],
      'required': [false],
      'minvalue': [0],
      'maxvalue': [0],
      'defaultvalue': [''],
      'searchsqlquery': [''],
      'precision': [0],
      'linkedform': [''],
      'stopduplicate': [false],
      'printable': [false],
      'infofield': [false],
      'tablename': [null]
    });

  }

  getFieldData() {
    this.fieldsConfigService.get(this.fieldData.id).subscribe((data: SingleResponseModel<FieldDictionaryDto>) => {
      if (data) {
        this.fieldData = data.result;
        if (this.fieldData) {
          this.form.patchValue({
            id: this.fieldData.id,
            tabsystemmenuid: this.fieldData.tabSystemMenuId,
            fieldname: this.fieldData.fieldName,
            fieldtype: this.fieldData.fieldType,
            displayaraname: this.fieldData.displayAraName,
            dislaylatname: this.fieldData.dislayLatName,
            displaylist: this.fieldData.displayList,
            filter: this.fieldData.filter,
            criteria: this.fieldData.criteria,
            required: this.fieldData.required,
            minvalue: this.fieldData.minValue,
            maxvalue: this.fieldData.maxValue,
            defaultvalue: this.fieldData.defaultValue,
            precision: this.fieldData.precision,
            printable: this.fieldData.printable,
            searchsqlquery: this.fieldData.searchSqlQuery,
            linkedform: this.fieldData.linkedForm,
            stopduplicate: this.fieldData.stopDuplicate,
            infofield: this.fieldData.infoField,
            tablename: this.fieldData.tableName,
          });
        }
      }
    });
  }

  onSubmit() {
    if (this.form.valid) {
      // console.log('form value', this.form.value)
      const formData: FieldDictionaryDto = this.form.value;
      this.fieldsConfigService.updateFieldDictionary(formData.id, formData).subscribe((res) => {
        this.baseService.showSuccessMessage(EDITSUCCESS);
      },
        (err) => {
          console.log('err', err);
          this.baseService.showErrorMessage(OPERERROR);
        });
    }
  }

 /*  clearConfig() {
    const formData: FieldDictionaryDto = this.form.value;
    if (formData.id) {
      this.fieldsConfigService.delete(formData.id).subscribe((res) => {
        this.baseService.showSuccessMessage(DELETESUCCESS);
      }, (err) => {
        console.log('err', err);
        this.baseService.showErrorMessage(OPERERROR);
      });
    }
  } */

}
